import React from 'react';
import type { FC } from 'react';
import { useIntl } from 'react-intl-next';

import { ContentType } from '../ImportContentDrawer';
import { Workflow } from '../Workflow';
import { i18n as notionI18n } from '../ImportNotionContentWorkflow';

type ImportMiroContentWorkflowProps = {
	closeDrawer: () => void;
};

export const ImportMiroContentWorkflow: FC<ImportMiroContentWorkflowProps> = ({ closeDrawer }) => {
	const { formatMessage } = useIntl();
	return (
		<Workflow
			contentType={ContentType.MIRO}
			progressTrackerStages={[
				{
					id: 'content',
					label: formatMessage(notionI18n.content),
					percentageComplete: 0,
					status: 'current',
				},
			]}
			steps={[() => <div>HI</div>]}
			closeDrawer={closeDrawer}
		/>
	);
};
